/**
 * Has the client finished paying an installment plan?
 *
 * Two ways to be done, and the screens used to know only the first:
 *
 * - the plan billed every installment on schedule (`cycleNumber` caught up), or
 * - it was **paid off early** (TRE-1511 / TRE-1725), which settles the balance
 *   in ONE charge and flips `accessPeriod.status` to `paid`. That path leaves
 *   `cycleNumber` where it stood on purpose — the counter numbers the invoices
 *   Stripe issued, and the payoff issues none. Reading it as "1 of 6 paid"
 *   turns a settled plan into an open one: the details panel announced a next
 *   installment and the timeline listed five future payments that will never be
 *   charged.
 *
 * Deliberately structural rather than typed to `SubscriptionProductAccessPeriod`:
 * the same shape reaches these components as a scheduled overlapping period and
 * as raw jsonb from SQL.
 */
export const areInstallmentsSettled = (
  accessPeriod:
    | { status?: string | null; installments?: number | null; cycleNumber?: number | null }
    | null
    | undefined,
): boolean => {
  if (!accessPeriod?.installments) {
    return false;
  }

  if (accessPeriod.status === "paid") {
    return true;
  }

  return typeof accessPeriod.cycleNumber === "number" && accessPeriod.cycleNumber >= accessPeriod.installments;
};
